<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3" v-if="!isFromDashBoard">{{'Cron Status'}}</strong>
          <h4 class="card-title m-0 float-left" v-if="isFromDashBoard">{{'Cron Status'}}</h4>
        </div>
        <div class="col-md-1" v-if="!isFromDashBoard">
          <download :tableId="'cron-status'" :fileName="'cron-status'"></download>
        </div>
        <div class="col-md-1" v-if="!isFromDashBoard">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5" v-if="!isFromDashBoard">
        <div class="col-md-3">
          <div class="form-group">
            <datepicker
              :input-class="'form-control'"
              :format="'dd-MM-yyyy'"
              v-model="ddate"
              @selected="getSelDate($event)"
            ></datepicker>
          </div>
        </div>
        <!-- <div class="col-md-3">
          <div class="form-group">
            <select class="form-control" v-model="status">
              <option value>Select Status</option>
              <option value="Pass">Success</option>
              <option value="Fail">Fail</option>
            </select>
          </div>
        </div> -->
        <!-- <div class="col-md-3">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group" style="margin-top: 3px;">
                <button type="button" class="btn btn-sm btn-primary" @click="filter()">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group" style="margin-top: 3px;">
                <button type="button" class="btn btn-sm btn-success" @click="reset()">
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table
          id="download-history"
          class="table table-sm first-td-padding table-bordered app-inner"
        >
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>
                <span v-if="!isFromDashBoard">{{(index+1)+(perPage*($refs.page.current_page-1))}}</span>
                <span v-else>{{(index+1)}}</span>
              </td>
              <td v-for="(field, ind) in tableFields" v-bind:key="ind+'-'+field.name+index">
                <span v-if="field.type==='datetime'">{{getDateTime(row[field.name])}}</span>
                <span v-else-if="field.name==='status'">
                  <span v-if="row[field.name] === 'Pass'">Success</span>
                  <span v-if="row[field.name] === 'Fail_Capitaline'">Fail</span>
                  <span v-if="row[field.name] === 'Fail' && field.title==='SMA Status'">Fail</span>
                  <span v-if="row[field.name] === 'Fail' && field.title==='Capitaline Status'">Fail</span>
                  <!-- <span
                    v-if="row[field.name] === 'Fail' && field.title==='Capitaline Status'"
                  >Success</span> -->
                </span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+actions.length+1)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <pagination
          v-if="!isFromDashBoard"
          ref="page"
          :pageName="pageType"
          :totPages="totalPages"
          :apiUrl="apiUrl"
          @changePage="pageChange"
        ></pagination>
        <div class="pull-right" v-if="isFromDashBoard">
          <router-link class="page-link" :to="'/activity-logs/cron-status'">View All</router-link>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import Datepicker from "vuejs-datepicker";
export default {
  mixins: [commonMixins],
  components: { Datepicker },
  name: "getDownload",
  props: ["isFromDashBoard"],
  created() {
    console.log("Config ", process.env.API_URL);
    if (this.isFromDashBoard) {
      this.url = this.apiUrl + this.page;
    }
    this.fetchData();
  },
  watch: {
    reload() {
      this.fillTable();
    }
  },
  data() {
    return {
      apiUrl: "cron/status/",
      pageType: "cron-status",
      ddate: new Date(),
      status: '',
      perPage: 15,
      apiMode: true,
      company: {},
      actions: [
        // {
        //   btnClass: "btn-info",
        //   icon: "fa-list cwhite",
        //   callback: this.viewRawData,
        //   tooltip: "Raw Data"
        // },
      ],
      tableFields: [
        {
          name: "cron",
          title: "Cron",
          type: "string"
        },
        {
          name: "co_code",
          title: "Code",
          type: "number"
        },
        {
          name: "status",
          title: "Capitaline Status",
          type: "string"
        },
        {
          name: "status",
          title: "SMA Status",
          type: "string"
        },
        {
          name: "date",
          title: "Date Time",
          type: "datetime"
        }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      page: 1,
      totalPages: 1,
    };
  },
  methods: {
    fetchData() {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = {my_date: this.getDate(this.ddate)};
        // let params = {};
        http.post(this.url, params, function(error, response) {
          console.log(response);
          if (response.responseType === "success") {
            if (!myself.isFromDashBoard) myself.fillableData = response.data;
            else myself.fillableData = response.data.slice(0, 5);
            myself.totalPages = response.total_pages;
          }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    pageChange(url) {
      console.log("changeUrl", url);
      this.url = url;
      this.fetchData();
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      
      console.log("Selected date", e);
      this.fetchData();
    },
    filter() {
      this.fetchData();
    },
    reset(){
      this.status = "";
      this.ddate = new Date();
      this.fetchData();
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/activity-logs/cron-status.vue